import React, { FC, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { Button } from '@portal/common/components';
import { DataExplorerSelectionResource } from '@portal/common/types';

import _ from '../../../locale';
import { MY_FAVORITES_ID } from '../../../router/paths';
import {
    getSelectedConditions,
    getSelectedConditionsDataTypes,
    getSelectedRefinementFilters,
} from '../../../store/data-explorer/selectors';
import AddToListDataExplorerDropdown from '../../AddToListDropdown/AddToListDataExplorerDropdown';

interface AddToListsProps {
    getExplorerSelection: () => DataExplorerSelectionResource;
}

const AddToLists: FC<AddToListsProps> = ({ getExplorerSelection }) => {
    const selectedConditionsDataTypes = useSelector(getSelectedConditionsDataTypes);
    const conditions = useSelector(getSelectedConditions);
    const refinementFilters = useSelector(getSelectedRefinementFilters);

    const [dataExplorerSelectedListsIds, setDataExplorerSelectedLists] = React.useState<string[]>(
        []
    );

    useEffect(() => {
        setDataExplorerSelectedLists([]);
    }, [conditions, refinementFilters]);

    const addSelectedList = (listId: string) => {
        setDataExplorerSelectedLists((state) => state.concat(listId));
    };

    const handleFavoritesResourceClick = useCallback(() => {
        addSelectedList(MY_FAVORITES_ID);
    }, []);

    const handleCustomListResourceClick = useCallback((_, listId) => {
        addSelectedList(listId);
    }, []);

    return (
        <AddToListDataExplorerDropdown
            item={getExplorerSelection()}
            customSelectedListsIds={dataExplorerSelectedListsIds}
            onFavoritesResourceClick={handleFavoritesResourceClick}
            onCustomListResourceClick={handleCustomListResourceClick}
        >
            {({ ref, toggleVisibility }) => (
                <Button
                    ref={ref}
                    onClick={toggleVisibility}
                    beforeIconSrc="/icons/ic-star.svg"
                    disabled={!selectedConditionsDataTypes}
                >
                    {_('lists_add_to_list')}
                </Button>
            )}
        </AddToListDataExplorerDropdown>
    );
};

export default AddToLists;
